export default "__VITE_ASSET__byVrBC3B__"